import i18n from '@dms/i18n';

import {VEHICLE_FORM_EVENTS} from '../../core/machine/constants/VEHICLE_FORM_EVENTS';
import {MechanicalReplacementServiceIntervals} from '../../core/types/RentalVehicle';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

interface LastReplacementMileageInputProps {
  name: MechanicalReplacementServiceIntervals;
}

/**
 * Numeric input component for entering the mileage at which a vehicle component was last replaced.
 * Used in service interval tracking to record the vehicle's mileage when a component was last replaced.
 * Automatically calculates the next replacement mileage when changed.
 *
 * @param props.name - The component name (e.g., 'engineOil', 'gearboxOil', 'timingBelt')
 */
export function LastReplacementMileageInput(props: LastReplacementMileageInputProps) {
  const {sendMachineEvent} = useVehicleFormContext();

  const handleChange = (value: number | null) => {
    sendMachineEvent({
      type: VEHICLE_FORM_EVENTS.LAST_REPLACEMENT_MILEAGE_CHANGED,
      name: props.name,
      value,
    });
  };

  return (
    <Field
      type="number"
      name={`serviceIntervals.${props.name}.lastReplacementMileage`}
      label={i18n.t('entity.vehicle.labels.mileageAtLastReplacement')}
      suffix={i18n.t('general.metric.km')}
      onChange={handleChange}
    />
  );
}
